/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputEditAdminChatChannel
 */
export interface InputEditAdminChatChannel {
    /**
     * 
     * @type {string}
     * @memberof InputEditAdminChatChannel
     */
    name: string;
}

/**
 * Check if a given object implements the InputEditAdminChatChannel interface.
 */
export function instanceOfInputEditAdminChatChannel(value: object): boolean {
    if (!('name' in value)) return false;
    return true;
}

export function InputEditAdminChatChannelFromJSON(json: any): InputEditAdminChatChannel {
    return InputEditAdminChatChannelFromJSONTyped(json, false);
}

export function InputEditAdminChatChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputEditAdminChatChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function InputEditAdminChatChannelToJSON(value?: InputEditAdminChatChannel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

